<template>
  <div class="column">
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.column {}
</style>
